import type { Claim } from "fhir/r4";
import moment from "moment";
import { v4 as uuid } from "uuid";

import * as FHIRUtils from "../fhirutils";

export function build(
  patientId: string,
  coverageId: string,
  payerOrgId: string,
  providerOrgId: string,
  diagCode: string,
  diagName: string,
  serviceDate: string,
  updatedBy: string
): Claim {
  const claimId = uuid();

  const claim: Claim = {
    resourceType: "Claim",
    id: claimId,
    status: "active",
    use: "claim",
    type: {
      coding: [
        {
          system: "http://terminology.hl7.org/CodeSystem/claim-type",
          code: "institutional",
        },
      ],
    },
    patient: {
      reference: "Patient/" + patientId,
    },
    created: moment(new Date()).format("YYYY-MM-DD"),
    billablePeriod: {
      start: serviceDate,
      end: serviceDate,
    },
    insurer: {
      reference: "Organization/" + payerOrgId,
    },
    provider: {
      reference: "Organization/" + providerOrgId,
    },
    priority: {
      coding: [
        {
          code: "normal",
        },
      ],
    },
    insurance: [
      {
        sequence: 1,
        focal: true,
        coverage: {
          reference: "Coverage/" + coverageId,
        },
      },
    ],
    diagnosis: [
      {
        sequence: 1,
        diagnosisCodeableConcept: {
          coding: [
            {
              system: "http://hl7.org/fhir/sid/icd-10",
              code: diagCode,
              display: diagName,
            },
          ],
        },
      },
    ],
  };

  return FHIRUtils.addUpdatedBy(claim, updatedBy);
}
